import { useRouter } from "next/router";
import { useCurrentUser } from "@hooks/use-current-user";
import Image from "@components/core/Image";
import staticSitesEntryPoint from "@utils/constants/staticSitesEntryPoint";

function HeaderAuth() {
  const router = useRouter();
  const user = useCurrentUser();

  const { locale, defaultLocale } = router;

  const homeUrl = user ? `${locale !== defaultLocale ? `/${locale}` : ""}/home` : `${process.env.NEXT_PUBLIC_CUSTOMER_WEBSITE}${staticSitesEntryPoint[locale]}`;
  
  return (
    <div className="border-bottom d-flex justify-content-center align-items-center onboarding-layout">
      <a href={homeUrl}>
        <Image src="logo" alt="logo" style={{ height: "24px" }} />
      </a>
    </div>
  );
}

export default HeaderAuth;
